import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { FooterItems } from './footerItems';

function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}

class FooterSection extends Component {
  render() {
    return (
      <div className="search-page-footer pt-3">
        <Container className="d-flex flex-column justify-content-center align-items-center">
          <div className="d-flex">
            { FooterItems.map((item, index) => 
              <div key={index}>
                {0 === index ? "" : "|"}
                <Link to={item.to} className="ml-3 mr-3">{item.label}</Link>
              </div>
            )}
          </div>
          <p className="mt-2">Copyright(c) 2020 Trontech Inc.</p>
        </Container>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
)(FooterSection);